<template>
  <div class="dispatcher-fleet no-scrollbar">
    <MainBackButton :forceHome="true" />
    <!-- <CommerceSettingsModal />
    <OrderDetailsModal />-->
    <LogisticsAddDriverModal :fleets="fleets" />

    <p class="has-text-left" style="padding-top: 17px">
      <span class="title is-5 has-text-link" style="padding-left:55px" @click="updateFleet">
        <span class="has-text-black">{{ $t("logistics.fleet") }}</span>
        &nbsp;{{ $t("Drivers") }}
      </span>
      <span class="is-pulled-right" style="margin-right:12px; margin-top:-5px">
        <span class="button icon is-medium is-dark is-outlined is-rounded" @click="workflowInfo">
          <i class="fa fa-cog" />
        </span>
      </span>
      <span
        class="button is-pulled-right is-success is-outlined has-text-weight-medium"
        style="margin-right:12px; margin-top:-5px; height:32px; padding:4px"
        @click="goto('dispatcher_jobs')"
      >{{ $t("logistics.jobs") }}</span>
    </p>

    <div class="columns is-mobile" style="width:100vw">
      <div class="column">
        <div class="field has-addons">
          <div class="control">
            <span class="button is-rounded side-btn" @click="toggleSearch">
              <span class="icon">
                <i class="fa fa-search has-text-link" />
              </span>
            </span>
          </div>
          <div class="control is-expanded">
            <input
              v-model="search"
              class="input is-rounded searchbox"
              @keyup="search = $event.target.value.toLowerCase()"
              type="text"
              :placeholder="searchPlaceholder"
            />
          </div>
        </div>
      </div>
      <div class="column is-narrow">
        <div class="buttons">
          <span class="button is-rounded is-link is-outlined" @click="addDriver">
            <span class="icon">
              <i class="fa fa-plus fa-lg" />
            </span>
          </span>
          <span class="button is-rounded is-link is-outlined" @click="toggleView">
            <span class="icon">
              <i v-if="listView" class="fa fa-globe" />
              <i v-else class="fa fa-list" />
            </span>
          </span>
        </div>
      </div>
    </div>

    <!-- Filters: Alphabet, Category, Distance, Favorite, New -->
    <div style="width:100%; margin-top:5px">
      <span class="buttons is-centered single-line" style="width:100vw">
        <span
          class="button is-rounded is-small"
          :class="{'is-link': showWorking}"
          @click="showWorking = !showWorking; toggleOptions()"
        >
          <i class="fa fa-spinner fa-spin" />
          &nbsp;{{ $t("logistics.working") }}
        </span>
        <span
          class="button is-rounded is-small"
          :class="{'is-link': vehicleTypes.length > 0 }"
          @click="toggleOptions('vehicles')"
        >
          <i class="fa fa-truck" />
          &nbsp;{{ $t("logistics.vehicle-type") }}
        </span>
        <!-- <span class="is-size-5 has-text-grey">|</span> -->
        <span
          v-show="listView"
          class="button is-rounded is-small"
          :class="{'is-link': sortBy}"
          @click="toggleOptions('sort')"
        >
          <i class="fa fa-sort-amount-down" />
          &nbsp;{{ $t("sort") }}
        </span>
      </span>
    </div>

    <div v-if="showOptions === 'vehicles'" style="width:100%">
      <span class="buttons is-centered single-line" style="width:100vw; padding-bottom:12px">
        <span
          class="button is-small"
          :class="{'is-info': vehicleTypes.length == 0}"
          @click="vehicleTypes = []; toggleOptions()"
        >All</span>
        <span
          v-for="c in categories"
          v-show="c"
          :key="c"
          class="button is-small"
          :class="{'is-info': vehicleTypes.includes(c)}"
          @click="selectVehicleType(c)"
        >
          <!-- {{ translateCategory(c) }} -->
          {{ c }}
        </span>
      </span>
    </div>

    <!-- style="width:100%; position:absolute; z-index:2; background-color:green;" -->
    <div v-if="showOptions === 'sort'" style="width:100%;">
      <span class="buttons is-centered single-line" style="width:100vw; padding-bottom:12px">
        <!-- <span
          class="button is-small"
          :class="{'is-info': vehicleTypes.length == 0}"
          @click="vehicleTypes = []"
        >All</span>-->
        <span
          v-for="s in sortOptions"
          :key="s"
          class="button is-small"
          :class="{'is-info': sortBy === s}"
          @click="sortBy = s; showSortOptions = false"
        >
          <!-- {{ translateCategory(c) }} -->
          {{ s }}
        </span>
      </span>
    </div>

    <logisticsFleetList v-show="listView" :filters="filters" :sort="sortBy" />
    <LogisticsFleetMap v-show="!listView" :filters="filters" />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import MainBackButton from "@/components/MainBackButton.vue";
import LogisticsFleetList from "@/components/LogisticsFleetList.vue";
import LogisticsFleetMap from "@/components/LogisticsFleetMap.vue";
import LogisticsAddDriverModal from "@/components/LogisticsAddDriverModal.vue";

export default {
  name: "DispatcherFleet",
  components: {
    MainBackButton,
    LogisticsFleetList,
    LogisticsFleetMap,
    LogisticsAddDriverModal
  },
  data() {
    return {
      listView: true,
      showWorking: false,
      showOptions: null, // which options to show
      vehicleTypes: [], // array of selected vehicle types
      showVehicleTypes: false,
      sortOptions: ["Name", "Time"],
      sortBy: null,
      showSortOptions: false,
      search: null,
      workflows: [], // all workflows on business, used to get fleets workflows
      // old
      sortedBy: "alphabet", // default sort
      searching: false,
      z: 0
    };
  },
  computed: {
    searchPlaceholder() {
      return this.$t("shop.search");
    },
    role() {
      return this.$store.getters.getLogisticsAgentRole;
    },
    workflow() {
      return this.role.workflow;
    },
    vehicles() {
      return this.$store.getters.getLogisticsFleet;
    },
    categories() {
      return [...new Set(this.vehicles.map(b => b.role.workflow_name))];
    },
    filters() {
      return {
        working: this.showWorking,
        vehicleTypes: this.vehicleTypes,
        search: this.search
      };
    },
    fleets() {
      if (!this.workflows) return [];
      return this.workflows.filter(w => w.workflow_type_name === "Fleet");
    }
  },
  created() {
    this.updateFleet();
    this.getFleetWorkflows();
  },
  activated() {
    this.updateFleet();
    this.updateLogisticsAgentFleetWorkflows();
  },
  mounted() {
    EventBus.$on("LOGISTICS_FLEET_RESET_FILTERS", () => this.reset());
  },
  methods: {
    updateFleet() {
      this.$store
        .dispatch("getLogisticsFleet", this.role.business_id)
        .catch(err => this.apiError(err));
    },
    getFleetWorkflows() {
      this.$store
        .dispatch("getWorkflows", this.role.business_id)
        .then(res => {
          console.log("fleet workflows", res.data);
          if (res.data) this.workflows = res.data;
        })
        .catch(err => this.apiError(err));
    },
    reset() {
      Object.assign(this.$data, this.$options.data()); // clears filters
      this.updateFleet(); // updates fleet
    },
    toggleOptions(opt) {
      if (this.showOptions === opt) this.showOptions = null;
      else this.showOptions = opt;
    },
    selectVehicleType(type) {
      if (this.vehicleTypes.includes(type)) {
        this.vehicleTypes = this.vehicleTypes.filter(t => t !== type);
      } else {
        this.vehicleTypes.push(type);
      }
    },
    addDriver() {
      this.displayModal(".logistics-add-driver-modal");
    },
    toggleSearch() {
      this.search = null;
    },
    toggleView() {
      this.z += 1;
      this.listView = !this.listView;
      EventBus.$emit("TOGGLE_FLEET_MAP");
      this.toggleOptions(null);
    },
    // select(type) {
    //   this.$store.commit("setShopsOrServices", type);
    //   EventBus.$emit("SHOP_LIST_CHANGE");
    //   EventBus.$emit("UPDATE_SHOP_MAP");
    // },
    // sortBy(type) {
    //   this.sortedBy = type;
    //   EventBus.$emit("SHOP_LIST_SORT", type);
    // },
    // search(e) {
    //   this.search = e.target.value;
    // EventBus.$emit("SHOP_LIST_SEARCH", text.toLowerCase());
    // },
    workflowInfo() {
      var YAML = require("json2yaml");
      var ymlText = YAML.stringify(this.workflow.data);
      this.$swal({
        title: `<i class='fa fa-cog' style='color:blue'></i>`,
        html: `<div style="text-align:left; white-space:pre-line; font-size:0.8em">
        <h3 style='font-size:1.2em;margin-bottom:8px'>Logistics Settings</h3>${ymlText}</div>`,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  }
};
</script>

<style scoped>
.logistics-fleet {
  height: 100vh;
  overflow: hidden;
}
.columns {
  margin: 0;
}
/* /////////////////////////// */
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
.single-line::-webkit-scrollbar {
  display: none;
}
.icon:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
.select {
  padding-right: 0;
}
.button {
  padding: 13px;
}
.side-btn {
  padding: 0 15px;
}
.input {
  padding: 0 12px;
}
</style>
